(function () {
  /**
   * @awaitingdeprecation
   */
  angular
    .module('binky.core.organizations.encryption')
    .constant('ORGANIZATION_ENCRYPTION_MIGRATION_CACHE_ID', 'OrganizationEncryptionMigration');
})();
